import { App } from 'vue'
import vColorDirective from './src/color.ts'

export default {
	install: (app: App) => {
		app.directive('color', vColorDirective)
	},
}

export { vColorDirective as vColor }
